export const trimId = (id: string, replaceWith = ''): string => {
  return id.replace('gid://shopify/Product/', replaceWith);
};

export const trimVariantId = (id: string, replaceWith = ''): string => {
  return id.replace('gid://shopify/ProductVariant/', replaceWith);
};

export const getVariantId = (variant: string) => {
  if (variant) {
    const variantId = trimVariantId(variant);

    if (variantId) {
      return `variant=${variantId}`;
    }
  }
  return '';
};
